module.exports = __webpack_public_path__ + "static/media/alice_chang.7765a3ea.png";